/*
 * dataLayer ecommerce GA4 — eventos de carrito (Grifos)
 * Intercepta fetch a /cart/add, /cart/change y /cart/update para emitir add_to_cart y
 * remove_from_cart sin depender de la lógica interna del tema:
 * - /cart/add devuelve la línea añadida (o { items: [...] }) → add_to_cart
 * - /cart/change y /cart/update devuelven el carrito con items_added / items_removed (lo que ha
 *   cambiado en esa petición: subir cantidad, bajarla o quitar la línea) → add_to_cart / remove_from_cart
 * view_cart (página /cart) se emite por Liquid en dl-ecommerce.liquid.
 */
(function () {
  if (window.__dlCartEventsInit) return;
  window.__dlCartEventsInit = true;
  window.dataLayer = window.dataLayer || [];

  function currency() {
    return (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  }

  // Línea de /cart/add.js: precios en céntimos
  function toItem(li, index) {
    var price = (li.price != null ? li.price : li.final_price || 0) / 100;
    return {
      item_id: li.sku || String(li.product_id || li.id || ''),
      item_name: li.product_title || li.title || '',
      item_brand: li.vendor || undefined,
      item_category: li.product_type || undefined,
      item_variant: li.variant_title || undefined,
      price: price,
      quantity: li.quantity || 1,
      index: index
    };
  }

  // Entrada de items_added / items_removed: precio en euros y el título lleva " - variante"
  function toItemCambio(li, index) {
    var nombre = li.product_title || li.title || '';
    var sufijo = li.variant_title ? ' - ' + li.variant_title : '';
    if (sufijo && nombre.slice(-sufijo.length) === sufijo) nombre = nombre.slice(0, -sufijo.length);
    var price = li.presentment_price != null ? Number(li.presentment_price) : Number(li.price) || 0;
    return {
      item_id: li.sku || String(li.product_id || li.variant_id || ''),
      item_name: nombre,
      item_brand: li.vendor || undefined,
      item_category: li.product_type || undefined,
      item_variant: li.variant_title || undefined,
      price: price,
      quantity: li.quantity || 1,
      index: index
    };
  }

  function push(event, items) {
    if (!items.length) return;
    var value = items.reduce(function (s, it) { return s + it.price * it.quantity; }, 0);
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: event,
      ecommerce: { currency: currency(), value: Math.round(value * 100) / 100, items: items }
    });
  }

  function pushAddToCart(data) {
    // /cart/add.js devuelve el line item, o { items: [...] } en bundles/multi
    var lines = (data && data.items) ? data.items : [data];
    push('add_to_cart', lines.filter(function (l) { return l && !l.status; }).map(toItem));
  }

  function pushCambio(data) {
    if (!data) return;
    push('add_to_cart', (data.items_added || []).map(toItemCambio));
    push('remove_from_cart', (data.items_removed || []).map(toItemCambio));
  }

  var origFetch = window.fetch;
  if (typeof origFetch === 'function') {
    window.fetch = function (input, init) {
      var url = (typeof Request !== 'undefined' && input instanceof Request) ? input.url : String(input || '');
      var promise = origFetch.apply(this, arguments);
      var handler = null;
      if (url.indexOf('/cart/add') !== -1) handler = pushAddToCart;
      else if (url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1) handler = pushCambio;
      if (handler) {
        promise.then(function (res) {
          if (!res || !res.ok) return;
          res.clone().json().then(handler).catch(function () {});
        }).catch(function () {});
      }
      return promise;
    };
  }
})();
